import { useQuery, useQueryClient } from 'react-query';
import { Http } from '../../services/Http';
import { Deal, UserRole } from '../../types';
import { QUERY_KEYS } from '../constants';

async function fetchDeals(includeArchived: boolean, role?: UserRole): Promise<Deal[]> {
  const params: Record<string, string | boolean> = {};
  if (includeArchived) {
    params.includeArchived = true;
  }
  if (role) {
    params.role = role;
  }
  const { data } = await Http.axios.get<Deal[]>(`/deal`, {
    params: Object.keys(params).length ? params : undefined,
  });
  return data;
}

export const useDeals = (includeArchived = false, role?: UserRole) => {
  return useQuery([QUERY_KEYS.DEALS, includeArchived, role], () => fetchDeals(includeArchived, role), {
    staleTime: Infinity,
    refetchInterval: false,
    refetchOnMount: true,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    refetchIntervalInBackground: false,
  });
};

export const useInvalidateDeals = () => {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries({
      queryKey: QUERY_KEYS.DEALS,
    });
  };
};
